export default "__VITE_ASSET__BnU2pzAm__"